import styled from "styled-components";

export const RestuarantDetailstyles = styled.div`
  .detail-page-section {
    margin: 0px 30px;
  }
  .breadcrumbs-section {
    margin-bottom: 20px;
    font-family: "Inter";
    font-size: 22.54px;
    font-weight: 500;
    line-height: 27.27px;
  }
  .breadcrumbs-section img {
    width: 25px;
    height: 25px;
    margin-left: -10px;
    cursor: pointer;
  }
  .detailpage-bannerimg {
    position: relative;
  }
  .detailpage-bannerimg img {
    width: 100%;
  }
  .banner-logo {
    position: absolute;
    bottom: -46px;
    left: 50px;
  }
  .banner-logo img {
    border: 2px solid #6c7e8a;
    background: #ffffff;
    box-shadow: 0px 0px 36px 0px #00000024;
    width: 90px;
    height: 90px;
    object-fit: contain;
    padding: 5px;
  }
  .banner-like-share-section {
    display: flex;
    justify-content: space-between;
    margin-left: 170px;
    margin-top: 10px;
    margin-bottom: 40px;
  }
  .banner-like-share-section h5 {
    font-family: Inter;
    font-size: 32px;
    font-weight: 600;
    line-height: 38.73px;
  }
  .banner-like-share-section .banner-like-share-section-btns {
    display: flex;
    gap: 20px;
    align-items: center;
  }
  .banner-like-share-section .banner-like-share-section-btns div {
    padding: 16px;
    background: #ffffff;
    box-shadow: 0px 0px 36px 0px #0000001c;
    cursor: pointer;
  }

  .banner-like-share-section .banner-like-share-section-btns div img {
    width: 32px;
    height: 32px;
  }

  .restuarant-cards-section {
    margin: 40px 0px;
  }
  .detailpage-bannerimg-text h5 {
    font-family: Inter;
    font-size: 32px;
    font-weight: 600;
    line-height: 38.73px;
    margin-bottom: 1rem;
  }
  .detailpage-bannerimg-text p {
    font-family: Inter;
    font-size: 20px;
    font-weight: 400;
    line-height: 26px;
  }
  .detailpage-bannerimg-text p span {
    color: #6c7e8a;
  }
  .more-offers-text {
    font-family: Inter;
    font-size: 26px;
    font-weight: 500;
    line-height: 30px;
    margin: 20px 0px;
  }
  .restuarant-card-division {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    column-gap: 20px;
    margin-bottom: 20px;
  }
  .restuarant-cards {
    box-shadow: 0px 0px 36px 0px #0000000a;
    padding: 20px;
  }
  .restuarant-cards .logo-and-like {
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;
    align-items: center;
  }
  .card-logo img {
    width: 60px;
    height: 60px;
    object-fit: contain;
  }
  .like-share-btn img {
    width: 20px;
    height: 20px;
    box-shadow: 0px 0px 36px 0px #0000001c;
    background: #ffffff;
  }
  .like-share-btn {
    display: flex;
    gap: 10px;
    justify-content: end;
  }
  .card-text-section h5 {
    font-family: Inter;
    font-size: 22px;
    font-weight: 500;
    line-height: 28px;
    height: 55px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    display: -moz-box;
    -moz-line-clamp: 2;
    -moz-box-orient: vertical;
    display: box;
    box-orient: vertical;
    line-clamp: 2;
  }
  .card-text-section p {
    font-family: Inter;
    font-size: 16px;
    font-weight: 400;
    line-height: 23px;
    height: 45px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    display: -moz-box;
    -moz-line-clamp: 2;
    -moz-box-orient: vertical;
    display: box;
    box-orient: vertical;
    line-clamp: 2;
  }

  .banner-logo {
    position: absolute;
    bottom: -46px;
    left: 50px;
  }
  .slick-arrow {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: #fff;
    color: #fff;
    font-size: 0px;
    content: "" !important;
    z-index: 9;
    box-shadow: 0px 0px 36px 0px rgba(0, 0, 0, 0.13);
    margin-top: -30px;
    display: flex !important;
    justify-content: center;
    align-items: center;
  }
  .slick-arrow::before {
    margin-bottom: 5px;
  }
  .ant-carousel .slick-prev::before {
    content: "<" !important;
    color: #000 !important;
    font-size: 25px;
    margin-bottom: 5px;
  }
  .ant-carousel .slick-next::before {
    content: ">" !important;
    color: #000 !important;
    font-size: 25px;
    margin-bottom: 5px;
  }
  .ant-carousel .slick-arrow:hover {
    background: #fff !important;
    color: #fff !important;
  }
  .top_brands_styled {
    position: relative;
    background: var(--www-farfetch-com-mine-shaft-4, rgba(34, 34, 34, 0.04));
    padding-top: 5px;
  }

  .ofefr_sm_banner {
    padding: 30px;
  }
  .slick-dots {
    bottom: 20px !important;
  }
  .ant-carousel .slick-dots li {
    width: 12px !important;
    height: 12px !important;
    border: 1px solid #ffff;
    border-radius: 50%;
  }
  .ant-carousel .slick-dots li button {
    height: auto !important;
  }

  .ant-carousel .slick-dots li.slick-active button {
    background: transparent !important;
    opacity: 1;
  }
  .ant-carousel .slick-dots li.slick-active {
    background: orange !important;
  }
  .ant-carousel .slick-dots li button:hover {
    background: transparent !important;
  }
  .banner_img_carsousel .slick-slide {
    // height: 477px;
    aspect-ratio: 100 / 36;
    div {
      height: 100%;
    }
  }

  .carouse_image_wrapper {
    position: relative;
    img {
      width: 100%;
      object-fit: cover;
    }
  }
  .carousel-arrow {
    position: absolute;
    top: 45%;
    border: none !important;
    cursor: pointer;
    z-index: 10;
    width: 40px;
    height: 40px;
    background: #ffffff;
    border-radius: 50%;
  }
  .carousel-arrow img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .left-arrow {
    left: 10px;
  }

  .right-arrow {
    right: 10px;
    rotate: 180deg;
  }
  .location-section {
    display: flex;
    align-items: center;
    justify-content: start;
    margin-top: 20px;
    margin-bottom: 20px;
    gap: 10px;
    p {
      margin-bottom: 0px;
    }
  }
  .button-section {
    display: flex;
    justify-content: end;

    button {
      display: inline-flex;
      height: 40px;
      width: 269px;
      justify-content: center;
      align-items: center;
      gap: 8px;
      border-radius: 34px;
      background: #000;
      color: #fff;
      margin-left: auto;
    }
  }

  // mobile view styles

  @media screen and (max-width: 767px) {
    .restuarant-card-division {
      grid-template-columns: repeat(1, 1fr);
    }
    .detailpage-bannerimg img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .detail-page-section {
      margin: 0px 16px;
    }
    .detailpage-bannerimg {
      height: 150px;
    }
    .banner-like-share-section {
      margin-left: 125px;
    }
    .banner-logo {
      left: 20px;
      width: 70px;
      height: 70px;
    }
    .mobile-list_wrapper .card-div .inner-img-sec {
     height: auto;
     width: 100%;
}
    .location{
      display: block;
    }
    .location .col-6{
     width:100%;
     max-width: 100%;
     justify-content:left;
     margin-bottom: 15px;
    }
    .location .col-6 button{
     margin-left: 0px;
     width: 100%;
    }
    .banner-like-share-section{
      display: block;
      margin-left: 0px;
    }
    .banner-like-share-section h5{
      padding-left: 100px;
      font-size: 20px;
    }
    .banner-like-share-section-btns{
      justify-content: space-between;
      margin-top: 20px;
    }
    .banner-like-share-section .banner-like-share-section-btns div{
      padding: 5px;
    }
    .banner-like-share-section .banner-like-share-section-btns div img{
      width: 25px;
      height: 25px;
    }
  }
`;
